import { chartKeys } from 'utils/constant';

const balance_currency = {
  chartTitle: 'Balance',
  chartKey: chartKeys.BALANCE_CURRENCY,
}

export default balance_currency;